import { render, staticRenderFns } from "./DamagePoints.vue?vue&type=template&id=0712cb64&lang=pug&"
import script from "./DamagePoints.vue?vue&type=script&lang=ts&"
export * from "./DamagePoints.vue?vue&type=script&lang=ts&"
import style0 from "./DamagePoints.vue?vue&type=style&index=0&id=0712cb64&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports